import { motion } from "framer-motion";
import { ArrowUpRight, Droplets } from "lucide-react";
import { ADDONS, WASH, waLink } from "@/data/site";
import { Reveal, SectionHead, useLang } from "./common";

export const AddOns = () => {
  const { t, lang } = useLang();
  return (
    <section id="addons" data-testid="addons-section" className="py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHead num={t.addons.num} kicker={t.addons.kicker} segs={t.addons.title} desc={t.addons.desc} testid="addons-head" />
        <div className="grid lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-5 relative rounded-[2rem] overflow-hidden min-h-[480px] group">
            <img src="/assets/wet.jpg" alt={t.addons.washAlt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.6s] group-hover:scale-105" />
            <div className="absolute inset-0 bg-[#0F295B]/45" />
            <div data-testid="wash-card" className="absolute inset-x-4 bottom-4 sm:inset-x-6 sm:bottom-6 rounded-3xl bg-white/85 backdrop-blur-xl p-6">
              <div className="flex items-center gap-3"><Droplets className="w-6 h-6 text-[#00A651]" /><p className="font-display text-xl text-[#0F295B]">{t.addons.washTitle}</p></div>
              <div className="mt-5 grid grid-cols-3 gap-2">
                {WASH.map((w) => (
                  <div key={w.cap} className="rounded-2xl bg-[#0F295B] text-center py-3">
                    <p className="text-xs text-slate-300">{w.cap}</p>
                    <p className="font-display text-lg text-[#F39C12]">{w.p}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 rounded-[2rem] bg-white border border-[#0F295B]/10 p-3 sm:p-5">
            <ul data-testid="addons-list">
              {t.addons.items.map((a, i) => (
                <motion.li key={a.t + a.s} whileHover={{ x: 6 }} transition={{ duration: 0.25 }} data-testid={`addon-row-${i}`}
                  className="group flex items-center justify-between gap-4 px-4 sm:px-5 py-4 rounded-2xl hover:bg-[#F8F9FA] border-b border-[#0F295B]/[0.07] last:border-0">
                  <div className="flex items-center gap-4 min-w-0">
                    <span className="font-mono2 text-xs text-[#4A5B78] w-6">{String(i + 1).padStart(2, "0")}</span>
                    <div className="min-w-0">
                      <p className="font-semibold text-[#0F295B]">{a.t}</p>
                      <p className="text-xs text-[#4A5B78]">{a.s}</p>
                    </div>
                  </div>
                  <p className="font-display text-lg sm:text-xl text-[#0F295B] whitespace-nowrap">{ADDONS[i].p}<span className="text-xs text-[#4A5B78] ml-1">{ADDONS[i].u}</span></p>
                </motion.li>
              ))}
            </ul>
            <a href={waLink(lang === "hi" ? "नमस्ते Vivan Energia, मुझे आपकी ऐड-ऑन सेवाओं के बारे में जानकारी चाहिए।" : "Hi Vivan Energia, I'd like to enquire about your add-on services.")} target="_blank" rel="noreferrer" data-testid="addons-enquire"
              className="mt-3 mx-2 mb-2 flex items-center justify-between rounded-2xl bg-[#0F295B] text-white px-5 py-4 font-bold hover:bg-[#00A651] transition-colors">
              {t.addons.enquire} <ArrowUpRight className="w-5 h-5" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
